/**
 * Created by JIocb on 02.07.2017.
 */

module Factive.Core
{
    import ArenaHelper = Arkadium.Game.ArenaHelper;
    import PanelName = Factive.Game.PanelName;
    import AnalyticsConstants = Factive.Game.AnalyticsConstants;
    import GameRoom = Factive.Game.GameRoom;
    import SoundConstants = Factive.Game.SoundConstants;
    export class PanelSupervisor
    {
        private _dc: Factive.Core.DependenciesContainer;
        private _pm:PanelManager;
        private _eb: EventBus;
        private _arenaHelper: ArenaHelper;
        private _startGameTimeMs:number;
        private _externalCreateDataCallBack: Function;
        private _externalCreateDataCallBackContext: any;

        constructor(dc:DependenciesContainer, private _gameRoom:GameRoom)
        {
            this._dc = dc;
            this._pm = this._dc.get("PanelManager");
            this._eb = this._dc.get("EventBus");
            this._arenaHelper = this._dc.get("ArenaHelper");

            this._startGameTimeMs = window.performance.now();
        }

        public initialize():void
        {
            this._pm.registerPanel(PanelName.DialogColorBonus,DialogColorBonusPanel);
            this._pm.registerPanel(PanelName.Achievement,AchievementPanel);
            this._pm.registerPanel(PanelName.Help,HelpPanel);
            this._pm.registerPanel(PanelName.GameEnd,GameEndPanel);
            this._pm.registerPanel(PanelName.AreYouSureQuit,AreYouSurePanel);
            this._pm.registerPanel(PanelName.Settings,SettingsPanel);
        }

        private callRefresh():void
        {
            this._arenaHelper.sendEventChange();
        }
        public openPanel(name:number,data?:any):void
        {
            switch(name)
            {
                case PanelName.Help:{this.openHelpPanel(data);break;}
                case PanelName.AreYouSureQuit:{this.openAYSPanel(data);break;}
                case PanelName.Achievement:{this.openAchievementPanel(data);break;}
                case PanelName.DialogColorBonus:{this.openColorBonusPanel(data);break;}
                case PanelName.GameEnd:{this.openGameEndPanel(data);break;}
                case PanelName.Settings:{this.openSettingsPanel(data);break;}
            }
        };

        private openHelpPanel(data?:any):void
        {
            this._eb.dispatch(AnalyticsConstants.ACTION_HELP, AnalyticsConstants.TOPIC_ANALYTIC);
            this._eb.add(EventBusConstants.EVENT_HELP_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI,this.handleHelpPanelEvent,this);
            this._pm.open(PanelName.Help,data);
        }

        private handleHelpPanelEvent(type, data):void
        {
            this._eb.remove(EventBusConstants.EVENT_HELP_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI,this.handleHelpPanelEvent, this);
            this._pm.close(PanelName.Help);
        }

        private openAYSPanel(data:any) {
            this._eb.add(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_NO,EventBusConstants.TOPIC_UI,this.handleAYSPanelEvent, this);
            this._eb.add(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_YES,EventBusConstants.TOPIC_UI,this.handleAYSPanelEvent, this);
            this._pm.open(PanelName.AreYouSureQuit,data);
        }

        protected handleAYSPanelEvent(evt:any): void
        {
            this._eb.remove(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_NO,EventBusConstants.TOPIC_UI,this.handleAYSPanelEvent, this);
            this._eb.remove(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_YES,EventBusConstants.TOPIC_UI,this.handleAYSPanelEvent, this);
            this._pm.close(PanelName.AreYouSureQuit);


            if(evt.type== EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_YES)
            {
                this.callRefresh();

                let delaySec:number = Math.floor((window.performance.now() - this._startGameTimeMs) / 1000);
                this._eb.dispatch(AnalyticsConstants.ACTION_TIME_QUIT, AnalyticsConstants.TOPIC_ANALYTIC, {seconds:delaySec});
                this._eb.dispatch(AnalyticsConstants.ACTION_QUIT_ROLLS, AnalyticsConstants.TOPIC_ANALYTIC, {value:evt.data.data.numberOfTotalRolls});
                this._eb.dispatch(AnalyticsConstants.ACTION_QUIT, AnalyticsConstants.TOPIC_ANALYTIC, {score:evt.data.data.score});

                if(evt.data.data.score == 0)
                {
                    this._eb.dispatch(AnalyticsConstants.ACTION_ABANDON, AnalyticsConstants.TOPIC_ANALYTIC, {score:evt.data.data.score});
                }

                this.openGameEndPanel({score:evt.data.data.score});
            }
        }

        private openAchievementPanel(data:any) {
            this._eb.add(EventBusConstants.EVENT_ACHIEVEMENT_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI,this.handleAchievementsPanelEvent,this);
            this._pm.open(PanelName.Achievement,data)
        }

        private handleAchievementsPanelEvent(evt:any):void
        {
            this._eb.remove(EventBusConstants.EVENT_ACHIEVEMENT_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI,this.handleAchievementsPanelEvent, this);
            this._pm.close(PanelName.Achievement);
        };
        private openColorBonusPanel(data:any) {
            this._eb.add(EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_YES,EventBusConstants.TOPIC_UI,this.handleDialogColorBonusPanelEvent,this);
            this._eb.add(EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_NO,EventBusConstants.TOPIC_UI,this.handleDialogColorBonusPanelEvent,this);

            this._pm.open(PanelName.DialogColorBonus, this._gameRoom.getNumRollsLeft() > 0 ? true : false);
        }

        protected handleDialogColorBonusPanelEvent(evt:any): void {

            this._eb.remove(EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_YES,EventBusConstants.TOPIC_UI,this.handleDialogColorBonusPanelEvent, this);
            this._eb.remove(EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_NO,EventBusConstants.TOPIC_UI,this.handleDialogColorBonusPanelEvent, this);

            var type = evt.type;

            if (type == EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_YES) {
                this._pm.close(PanelName.DialogColorBonus);

                this._eb.dispatch(EventBusConstants.GAMEPLAY_ACTIVATE_COLOR_BONUS,EventBusConstants.GAMEPLAY,{result:true});

            }
            else if (type == EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_NO)
            {
                this._pm.close(PanelName.DialogColorBonus);
                this._eb.dispatch(EventBusConstants.GAMEPLAY_ACTIVATE_COLOR_BONUS,EventBusConstants.GAMEPLAY,{result:false});
            }
        };

        private openGameEndPanel(data:any):void
        {
            this._eb.add(EventBusConstants.EVENT_GAME_END_PANEL_PRESS_OK,EventBusConstants.TOPIC_UI,this.handleGameEndPanelPress,this);
            this._pm.open(PanelName.GameEnd,{score:data.score})
        }

        private handleGameEndPanelPress(evt:any):void
        {
            let sm:ISoundManager = this._dc.get("SoundManager");
            sm.stopSound(SoundConstants.BG_MUSIC);

            this._eb.remove(EventBusConstants.EVENT_GAME_END_PANEL_PRESS_OK,EventBusConstants.TOPIC_UI,this.handleGameEndPanelPress,this);
            this._pm.close(PanelName.GameEnd);

            let showInternalGameEnd:boolean = this._arenaHelper.shouldShowInternalGameEnd();
            if(showInternalGameEnd == true)
            {
                this._gameRoom.restart();
            }
            else
            {
                if (sm.destroy) {
                    sm.destroy();
                }

                this._eb.dispatch(AnalyticsConstants.ACTION_SUBMIT, AnalyticsConstants.TOPIC_ANALYTIC, {score:evt.data.data.score});
                this._arenaHelper.sendGameEnd(evt.data.data.score);
            }
        };

        public destroy():void
        {
            this._eb.remove(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_NO,EventBusConstants.TOPIC_UI,this.handleAYSPanelEvent, this);
            this._eb.remove(EventBusConstants.EVENT_ARE_YOU_SURE_PANEL_PRESS_YES,EventBusConstants.TOPIC_UI,this.handleAYSPanelEvent, this);
            this._eb.remove(EventBusConstants.EVENT_ACHIEVEMENT_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI,this.handleAchievementsPanelEvent, this);
            this._eb.remove(EventBusConstants.EVENT_GAME_END_PANEL_PRESS_OK,EventBusConstants.TOPIC_UI,this.handleGameEndPanelPress,this);
            this._eb.remove(EventBusConstants.EVENT_HELP_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI,this.handleHelpPanelEvent, this);
            this._eb.remove(EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_YES,EventBusConstants.TOPIC_UI,this.handleDialogColorBonusPanelEvent, this);
            this._eb.remove(EventBusConstants.EVENT_COLOR_BONUS_PANEL_PRESS_NO,EventBusConstants.TOPIC_UI,this.handleDialogColorBonusPanelEvent, this);

            this._dc = null;
            this._pm = null;
            this._eb = null;
            this._arenaHelper = null;

            this._externalCreateDataCallBack = null;
            this._externalCreateDataCallBackContext = null;
        }

        private openSettingsPanel(data: any) {
            this._eb.add(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_QUIT,EventBusConstants.TOPIC_UI,this.handleSettingsPanelPress,this);
            this._eb.add(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_HELP,EventBusConstants.TOPIC_UI,this.handleSettingsPanelPress,this);
            this._eb.add(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_CLOSE,EventBusConstants.TOPIC_UI,this.handleSettingsPanelPress,this);
            this._pm.open(PanelName.Settings,{})
        }

        private handleSettingsPanelPress(evt:any ) {


            this._eb.remove(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_QUIT,EventBusConstants.TOPIC_UI,this.handleSettingsPanelPress,this);
            this._eb.remove(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_HELP,EventBusConstants.TOPIC_UI,this.handleSettingsPanelPress,this);
            this._eb.remove(EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_CLOSE,EventBusConstants.TOPIC_UI,this.handleSettingsPanelPress,this);

            switch (evt.type)
            {
                case EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_QUIT:{this.openAYSPanel(this.createDataForGameEnd());break;}
                case EventBusConstants.EVENT_SETTINGS_PANEL_PRESS_HELP:{this.openHelpPanel();break;}
            }
            this._pm.close(PanelName.Settings);
        }

        public setGameEndDataCreationFunction(callback:Function,context:any):any
        {
            this._externalCreateDataCallBack = callback;
            this._externalCreateDataCallBackContext = context;
        }
        private createDataForGameEnd():any
        {
            if(this._externalCreateDataCallBack && this._externalCreateDataCallBackContext)
            {
                return this._externalCreateDataCallBack.call(this._externalCreateDataCallBackContext);
            }
            return null;
        }
    }
};


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Panel/PanelSupervisor.ts